"use client";

import { useEffect, useState } from "react";

export default function BeforeAfterSlider({
  before,
  after,
  beforeLabel = "Before",
  afterLabel = "After",
  className = "",
  autoplay = true,
}: {
  before: string;
  after: string;
  beforeLabel?: string;
  afterLabel?: string;
  className?: string;
  autoplay?: boolean;
}) {
  const [pos, setPos] = useState(50);
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (!autoplay || touched) return;
    let t = 0;
    const id = window.setInterval(() => {
      t += 0.04;
      setPos(50 + Math.sin(t) * 28);
    }, 40);
    return () => window.clearInterval(id);
  }, [autoplay, touched]);

  return (
    <div className={`relative select-none overflow-hidden ${className}`}>
      <img src={after} alt="" className="absolute inset-0 h-full w-full object-cover object-top" draggable={false} />
      <img
        src={before}
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-top"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
        draggable={false}
      />
      <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-white shadow" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 left-1/2 flex h-8 w-8 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-xs font-bold text-gray-700 shadow-md">
          ⇆
        </div>
      </div>
      <span className="pointer-events-none absolute left-3 bottom-3 rounded-full bg-black/55 px-2.5 py-1 text-[11px] font-semibold text-white">
        {beforeLabel}
      </span>
      <span className="pointer-events-none absolute right-3 bottom-3 rounded-full bg-black/55 px-2.5 py-1 text-[11px] font-semibold text-white">
        {afterLabel}
      </span>
      <input
        type="range"
        min={0}
        max={100}
        value={pos}
        aria-label="Compare before and after"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onChange={(e) => {
          setTouched(true);
          setPos(Number(e.target.value));
        }}
        className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
      />
    </div>
  );
}
